
import { Component, Vue } from "vue-property-decorator";
import MilSymbol from "@/components/MilSymbol.vue";
import SettingsSpecific from "@/components/SettingsSpecific.vue";
import { SettingsPanelMixins } from "@/components/mixins";
import { mixins } from "vue-class-component";
import { EventBus, UNIT_CLICK } from "@/eventbus";
import { ChartItemType, PartialOrbChartOptions, UnitSpecificOptions } from "orbatchart";

@Component({
  components: { MilSymbol, SettingsSpecific }
})

export default class SettingsUnit extends mixins(SettingsPanelMixins) {
  mounted() {
    EventBus.$on(UNIT_CLICK, (id) => {
      this.activeSettingsPanel = 3;
      this.$store.dispatch("selectChartItem", { itemType: ChartItemType.Unit, id });
    });
  }

  get currentUnitId() {
    return this.$store.state.ui.selectedUnitId;
  }

  get itemIndex() {
    return this.items.findIndex(value => value.id === this.currentUnitId);
  }

  set itemIndex(value) {

  }

  get currentOptions() {
    if (this.currentUnitId === null) return null;
    return this.unitOptions[this.currentUnitId];
  }

  get unitOptions(): UnitSpecificOptions {
    return this.$store.state.chart.unitOptions;
  }

  get unitMap() {
    return this.$store.getters.unitMap;
  }

  get currentUnit() {
    return this.currentUnitId ? this.unitMap[this.currentUnitId] : null;
  }

  get items() {
    return Object.entries(this.unitOptions)
      .map(([key, value]) => {
          let unit = this.unitMap[key];
          return { name: unit.name, id: key, sidc: unit.sidc }
        }
      );
  }

  destroyed() {
    EventBus.$off(UNIT_CLICK);
  }

  clearSpecific(name) {
    this.$store.dispatch('clearSpecificUnitOption', { id: this.currentUnitId, name });
  }

  selectUnit(item) {
    this.$store.dispatch("selectChartItem", {itemType: ChartItemType.Unit, id:item.id});
  }

  onUpdate(value: PartialOrbChartOptions) {
    this.$store.commit('updateUnitOptions', { id: this.currentUnitId, value });
  }

  clearUnitSettings(item) {
    this.$store.commit('clearUnitOptions', item.id);
  }

};

